// extracted by mini-css-extract-plugin
module.exports = {"transform":"Transformer_transform__1dF7m"};